module.exports = __webpack_public_path__ + "static/media/coins.6ce40143.svg";